const HEAD = ['Pitch Priority', 'Priority Label', 'Deliverable', 'Quality', 'Full Name', 'IG Handle', 'IG Link', 'IG Followers', 'Category', 'City', 'State', 'Phone', 'Email', 'IG Avg Views', 'IG ER%'];
const TAIL = ['Fit Score', 'Fit Notes', 'Manager Notes'];

const esc = (v) => {
  const s = v == null ? '' : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const exportShortlistCsv = (rows, brandName, costCols) => {
  const lines = [[...HEAD, ...costCols.map((c) => c.label), ...TAIL].map(esc).join(',')];
  rows.forEach((c) => {
    lines.push([
      c.pitch_priority, c.priority_label, c.deliverable, c.quality_tier, c.name, c.instagram_handle ? `@${c.instagram_handle}` : '',
      c.instagram_link, c.instagram_followers, c.category, c.city, c.state, c.phone, c.email,
      c.instagram_avg_views, c.instagram_engagement_rate, ...costCols.map((col) => c[col.key] || '—'), c.fit_score, c.fit_notes, c.manager_note,
    ].map(esc).join(','));
  });
  const blob = new Blob([`\ufeff${lines.join('\n')}`], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `${(brandName || 'campaign').replace(/[^a-z0-9]+/gi, '_')}_creator_suggestions.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
};
